type Props = React.PropsWithChildren<{
  name?: string;
  required?: boolean;
}>;

const Label = ({ name, children, required }: Props) => (
  <label
    htmlFor={name}
    className="block mb-2 text-sm font-medium text-gray-900"
  >
    {children}
    {required && <span className="ml-1 text-blue-700">*</span>}
  </label>
);

export default Label;
